import {
    getAircraftsCompared,
    hasAircraftCompared, 
    isAircraftComparedFlightInitiator,
    switchAircraftCompared,
} from "~/helpers/aircraftCompare";

export default function useAircraftCompare() {
    const [items, setItems] = React.useState([])
    
    const updateAircraftsCompared = () => {
        setItems(getAircraftsCompared())
    }

    React.useEffect(() => {
        const disposeAdd = listenEvent('react.aircraftComparedAdded', updateAircraftsCompared)
        const disposeRemove = listenEvent('react.aircraftComparedRemoved', updateAircraftsCompared)

        return () => {
            disposeAdd()
            disposeRemove()
        }
    }, [])

    const isItemInCompare = (aircraftId) => {
        return hasAircraftCompared(aircraftId)
    }

    const isItemCompareInitiator = (aircraftId, itemId) => {
        return isAircraftComparedFlightInitiator(aircraftId, itemId)
    }

    const toggleItem = (aircraft, initiatorId) => {
        switchAircraftCompared({...aircraft, initiator_id: initiatorId})
    }

    const openCompareModal = React.useCallback(() => {
        $.fancybox.open({
            src: '#reactAircraftCompareModal',
            props: {
                tab: items.length > 0 ? 'models' : 'classes',
            },
            afterShow: () => {
                raiseEvent('react.openCompareAircraft', {});
            },
            afterClose: () => {
                raiseEvent('react.openCompareAircraft', {});
            }
        })
    }, [items])
    
    return {
        items,
        isItemInCompare,
        isItemCompareInitiator,
        toggleItem,
        openCompareModal,
    }
}
